import { connect } from 'react-redux';
import {
  getDailyBlotterColumnsDefinition,
  getDailyBlotterQuotesId,
} from 'state/blotters/dailyBlotter/dailyBlotter.selectors';
import type { AppState } from 'state/state.model';

export interface StateProps {
  dailyBlotterQuotesId: string[];
  dailyBlotterColumnsDefinition: any[];
}

export type DailyBlotterTableState = StateProps;

export const mapStateToProps = (state: AppState): StateProps => {
  return {
    dailyBlotterQuotesId: getDailyBlotterQuotesId(state)!,
    dailyBlotterColumnsDefinition: getDailyBlotterColumnsDefinition(state),
  };
};

export const connectDailyBlotterTable = connect(mapStateToProps);
